var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAuthenticated)?_c('Hook',{on:{"created":function($event){return _vm.authenticatedChanged()},"beforeDestroy":function($event){return _vm.authenticatedChanged()}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }